var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.handleCreateApiToken($event)
          }
        }
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("p", [_vm._v(" " + _vm._s(_vm.T.apiTokenDescription) + " ")])
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "w-100" }, [
            _vm._v(" " + _vm._s(_vm.T.apiTokenName) + " "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.tokenName,
                  expression: "tokenName"
                }
              ],
              staticClass: "form-control username-input",
              attrs: { autocomplete: "off", size: "20", type: "text" },
              domProps: { value: _vm.tokenName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.tokenName = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "form-group text-right" }, [
          _c(
            "button",
            { staticClass: "btn btn-primary", attrs: { type: "submit" } },
            [_vm._v(" " + _vm._s(_vm.T.apiTokenAdd) + " ")]
          )
        ])
      ]
    ),
    _vm.apiTokens.length == 0
      ? _c("div", [
          _c("div", { staticClass: "empty-category" }, [
            _vm._v(" " + _vm._s(_vm.T.profileApiTokensEmpty) + " ")
          ])
        ])
      : _c("table", { staticClass: "table table-striped table-over" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenName))]),
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenTimestamp))]),
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenLastTimeUsed))]),
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenResetTime))]),
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenRemaining))]),
              _c("th", [_vm._v(_vm._s(_vm.T.apiTokenLimit))]),
              _c("th")
            ])
          ]),
          _c(
            "tbody",
            _vm._l(_vm.apiTokens, function(apiToken) {
              return _c("tr", { key: apiToken.name }, [
                _c("td", [_vm._v(_vm._s(apiToken.name))]),
                _c("td", [_vm._v(_vm._s(_vm.formatTime(apiToken.timestamp)))]),
                _c("td", [_vm._v(_vm._s(_vm.formatTime(apiToken.last_used)))]),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatTime(apiToken.rate_limit.reset)))
                ]),
                _c("td", [_vm._v(_vm._s(apiToken.rate_limit.remaining))]),
                _c("td", [_vm._v(_vm._s(apiToken.rate_limit.limit))]),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.$emit("revoke-api-token", apiToken.name)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.apiTokenRevoke) + " ")]
                  )
                ])
              ])
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }